import { observer } from 'mobx-react-lite';

import { useCalendarRealtimeSubscriberPresenter } from './CalendarRealtimeSubscriber.presenter';

export const CalendarRealtimeSubscriber = observer((): null => {
  useCalendarRealtimeSubscriberPresenter();

  return null;
});
